<template>
  <div class="ml-5 mr-5 pb-4">
    <b-row class="mt-4">
      <b-col align-self="center">
        <h4>Sollarbeitszeit: Anzahl Stunden / Tag, Woche, Monat oder Jahr</h4>
        <hr>
      </b-col>
    </b-row>
    <u-error-handling
      v-if="targetWorkingTimeErrorObject"
      :error-object="targetWorkingTimeErrorObject"
    />
    <u-loader v-if="isLoading" />
    <div v-else>
      <!-- Row 1 - Tägliche Arbeitszeit -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_DailyWorkhours"
            :disabled="!canUserEdit"
            color="#e72b37"
            hide-details
            @change="changedCheckbox(1)"
          />
        </b-col>
        <b-col
          class="pl-0 pr-2"
          cols="auto"
        >
          <v-text-field
            v-model="textinput_DailyWorkhours"
            :disabled="checkBox_DailyWorkhours && canUserEdit ? false : true"
            class="textField"
          />
        </b-col>
        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-0"
        >
          h /Tag (tägliche, durchschnittliche Arbeitszeit)
        </b-col>
      </b-row>
      <!-- Validate Row 1 -->
      <b-row
        v-if="isNaN(textinput_DailyWorkhours)"
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <!-- Row 2 - Wöchentliche Arbeitszeit -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_WeeklyWorkhours"
            :disabled="!canUserEdit"
            color="#e72b37"
            hide-details
            @change="changedCheckbox(2)"
          />
        </b-col>
        <b-col
          class="pl-0 pr-2"
          cols="auto"
        >
          <v-text-field
            v-model="textinput_WeeklyWorkhours"
            :disabled="checkBox_WeeklyWorkhours && canUserEdit ? false : true"
            class="textField"
          />
        </b-col>
        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-0"
        >
          h /Woche (wöchentliche, durchschnittliche Arbeitszeit)
        </b-col>
      </b-row>
      <!-- Validate Row 2 -->
      <b-row
        v-if="isNaN(textinput_WeeklyWorkhours)"
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <!-- Row 3 - Monatliche Arbeitszeit -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_MonthlyWorkhours"
            :disabled="!canUserEdit"
            color="#e72b37"
            hide-details
            @change="changedCheckbox(3)"
          />
        </b-col>
        <b-col
          class="pl-0 pr-2"
          cols="auto"
        >
          <v-text-field
            v-model="textinput_MonthlyWorkhours"
            :disabled="checkBox_MonthlyWorkhours && canUserEdit ? false : true"
            class="textField"
          />
        </b-col>
        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-0"
        >
          h /Monat (monatliche, durchschnittliche Arbeitszeit)
        </b-col>
      </b-row>
      <!-- Validate Row 3 -->
      <b-row
        v-if="isNaN(textinput_MonthlyWorkhours)"
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <!-- Row 4 - Jährliche Arbeitszeit -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_YearlyWorkhours"
            :disabled="!canUserEdit"
            color="#e72b37"
            hide-details
            @change="changedCheckbox(4)"
          />
        </b-col>
        <b-col
          class="pl-0 pr-2"
          cols="auto"
        >
          <v-text-field
            v-model="textinput_YearlyWorkhours"
            :disabled="checkBox_YearlyWorkhours && canUserEdit ? false : true"
            class="textField"
          />
        </b-col>
        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-0"
        >
          h /Jahr (jährliche, durchschnittliche Arbeitszeit)
        </b-col>
      </b-row>
      <!-- Validate Row 4 -->
      <b-row
        v-if="isNaN(textinput_YearlyWorkhours)"
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <!-- Row 5 - andere Regelungen, welche? -->
      <!-- Row 5 Part 1/2 - andere Regelungen -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_OtherRules"
            :disabled="!canUserEdit"
            class="ma-0"
            color="#e72b37"
            hide-details
            @change="changedCheckbox(5)"
          />
        </b-col>

        <b-col
          align-self="center"
          class="ml-0 pl-0"
        >
          andere Regelungen, welche?
        </b-col>
      </b-row>

      <!-- Row 5 Part 2/2 - andere Regelungen -->
      <!-- ander Regelungen start-->
      <b-row
        v-for="(otherRule, otherRuleIndex) in inputs_OtherRules"
        :key="otherRuleIndex"
      >
        <b-col
          cols="auto"
          style="width: 48px"
        />
        <b-col
          align-self="center"
          class="ml-2 pl-0 pt-2"
          cols="auto"
        >
          Von
        </b-col>
        <!-- Datepicker von -->
        <b-col
          class="pl-0 pr-1"
          cols="auto"
        >
          <u-date-picker
            v-model="otherRule.dateFrom"
            :disabled="checkBox_OtherRules ? false : true"
            label=""
          />
        </b-col>
        <b-col
          align-self="center"
          class="ml-2 pl-0 pt-2"
          cols="auto"
        >
          bis
        </b-col>
        <!-- Datepicker bis -->
        <b-col
          class="pl-2 pr-1"
          cols="auto"
        >
          <u-date-picker
            v-model="otherRule.dateTo"
            :disabled="checkBox_OtherRules ? false : true"
            label=""
          />
        </b-col>
        <b-col
          align-self="center"
          class="ml-4 pl-0 pt-2"
          cols="auto"
        >
          Sollzeit
        </b-col>
        <b-col
          class="pl-0 pr-1"
          cols="auto"
        >
          <v-text-field
            v-model="otherRule.value"
            :disabled="checkBox_OtherRules ? false : true"
            class="textField"
          />
        </b-col>
        <b-col>
          <button
            v-if="checkBox_OtherRules && canUserEdit ? true : false"
            class="mt-3 btn btn-danger"
            placement="bottom"
            title="Diese Reglung entfernen"
            type="button"
            @click="RemoveOtherRuleEntry(otherRuleIndex)"
          >
            <i class="fas fa-trash-alt" />
          </button>
        </b-col>
      </b-row>
      <b-row>
        <button
          v-if="checkBox_OtherRules && canUserEdit ? true : false"
          class="btn btn-success ml-3"
          placement="bottom"
          title="Regelung hinzufügen"
          type="button"
          @click="AddBlankOtherRule"
        >
          <i class="fas fa-plus" />
        </button>
      </b-row>
      <!-- Validate Row 5 -->
      <b-row
        v-if="
          isNaN(textinput_OtherRules_TimeFrom) ||
            isNaN(textinput_OtherRules_TimeTo)
        "
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <br>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="success"
            tile
            @click="saveTargetWorkingTime"
          >
            <i class="fas fa-save pr-2" />
            Speichern
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="#e72b37"
            style="color: white"
            tile
            @click="resetWorkitems"
          >
            <i class="fas fa-ban pr-2" />
            Abbrechen
          </v-btn>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <h4>Arbeitstage</h4>
          <hr>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          align-self="center"
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_WeeklyWorkDays"
            :disabled="!canUserEdit"
            class="ma-0"
            color="#e72b37"
            hide-details
          />
        </b-col>
        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-3 pr-2"
          cols="auto"
        >
          Arbeitstage pro Woche:
        </b-col>
        <b-col cols="auto">
          <v-text-field
            v-model="textinput_WeeklyWorkDays"
            :disabled="!canUserEdit || !checkBox_WeeklyWorkDays"
            :rules="[validationRules.minDays, validationRules.maxDays]"
            type="number"
            :hide-details="false"
          />
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="success"
            tile
            @click="saveTargetWorkingTime"
          >
            <i class="fas fa-save pr-2" />
            Speichern
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="#e72b37"
            style="color: white"
            tile
            @click="resetWorkitems"
          >
            <i class="fas fa-ban pr-2" />
            Abbrechen
          </v-btn>
        </b-col>
      </b-row>
      <!--Höchstarbeitszeit-->
      <b-row class="mt-4 pt-4">
        <b-col align-self="center">
          <h4>Höchstarbeitszeit</h4>
          <hr>
        </b-col>
      </b-row>
      <u-error-handling
        v-if="maxWeeklyWorkHoursErrorObject"
        :error-object="maxWeeklyWorkHoursErrorObject"
      />
      <!-- Row 6 - Wöchentliche Höchstarbeitszeit -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_MaximumWorkhours_Gav"
            :disabled="!canUserEdit"
            color="#e72b37"
            hide-details
            @change="changedCheckboxMaximumWorkhours(2)"
          />
        </b-col>

        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-0 pr-2"
          cols="auto"
        >
          Wöchentliche Höchstarbeitszeit gemäss GAV:
        </b-col>
        <b-col
          class="pl-0 pr-2"
          cols="auto"
        >
          <v-text-field
            v-model="textinput_MaximumWorkhours_Gav"
            :disabled="
              checkBox_MaximumWorkhours_Gav && canUserEdit ? false : true
            "
            class="custom-normal-textinput"
          />
        </b-col>
      </b-row>
      <!-- Validate Row 6 -->
      <b-row
        v-if="isNaN(textinput_MaximumWorkhours_Gav)"
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <!-- Row 7- Wöchentliche Höchstarbeitszeit gemäss Artikel 9 ArG -->
      <!-- Row 7- Part 1/3 -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_MaximumWorkhours_Art9"
            :disabled="!canUserEdit"
            class="ma-0"
            color="#e72b37"
            hide-details
            @change="changedCheckboxMaximumWorkhours(1)"
          />
        </b-col>

        <b-col
          align-self="center"
          class="ml-0 pl-0 pt-2"
        >
          Wöchentliche Höchstarbeitszeit gemäss Artikel 9 ArG:
        </b-col>
      </b-row>
      <!-- Row 7- Part 2/3 -->
      <b-row class="pt-0 mt-0">
        <b-col
          cols="auto"
          style="width: 48px"
        />
        <b-col
          class="ml-0 pl-0 pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_MaximumWorkhours_Art9_45"
            :disabled="
              checkBox_MaximumWorkhours_Art9 && canUserEdit ? false : true
            "
            class="ma-0"
            color="#e72b37"
            @change="
              changedCheckboxMaximumWorkhoursArt(
                'checkBox_MaximumWorkhours_Art9_45',
              )
            "
          />
        </b-col>
        <b-col class="pt-2 pl-0">
          45 Stunden
        </b-col>
      </b-row>
      <!-- Row 7- Part 3/3 -->
      <b-row class="pt-0 mt-0">
        <b-col
          cols="auto"
          style="width: 48px"
        />
        <b-col
          class="ml-0 pl-0 pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_MaximumWorkhours_Art9_50"
            :disabled="
              checkBox_MaximumWorkhours_Art9 && canUserEdit ? false : true
            "
            class="ma-0"
            color="#e72b37"
            @change="
              changedCheckboxMaximumWorkhoursArt(
                'checkBox_MaximumWorkhours_Art9_50',
              )
            "
          />
        </b-col>
        <b-col class="pt-2 pl-0">
          50 Stunden
        </b-col>
      </b-row>
      <hr class="custom_hr">

      <!-- Row 8 - Tägliche Höchstarbeitszeit -->
      <b-row class="mt-4">
        <b-col
          class="pr-0"
          cols="auto"
        >
          <v-checkbox
            v-model="checkBox_MaxDailyWorkHours"
            :disabled="!canUserEdit"
            color="#e72b37"
            hide-details
          />
        </b-col>

        <b-col
          align-self="center"
          class="pt-2 ml-0 pl-0 pr-2"
          cols="auto"
        >
          Tägliche Höchstarbeitszeit gemäss GAV:
        </b-col>
        <b-col
          class="pl-0 pr-2"
          cols="auto"
        >
          <v-text-field
            v-model="textInput_MaxDailyWorkHours"
            :disabled="checkBox_MaxDailyWorkHours && canUserEdit ? false : true"
            class="custom-normal-textinput"
          />
        </b-col>
      </b-row>

      <!-- Validate Row 9 -->
      <b-row
        v-if="isNaN(textinput_MaximumWorkhours_DailyTime)"
        class="pt-0"
      >
        <b-col cols="4">
          <b-alert
            show
            variant="danger"
          >
            {{ errorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <hr class="custom_hr">
      <!-- Last Row - Speichern Abbrechen -->
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="success"
            tile
            @click="saveMaxWeeklyWorkingHours"
          >
            <i class="fas fa-save pr-2" />
            Speichern
          </v-btn>
        </b-col>
        <b-col cols="auto">
          <v-btn
            v-if="canUserEdit"
            color="#e72b37"
            style="color: white"
            tile
            @click="resetWorkitems"
          >
            <i class="fas fa-ban pr-2" />
            Abbrechen
          </v-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  LoadTargetWorkingTime,
  SaveTargetWorkingTime,
  LoadMaxWeeklyWorkingHours,
  SaveMaxWeeklyWorkingHours,
} from "@/services/minimum.wage.services/zuschlagsrechner/worktime.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import UDatePicker from "@/components/common/UDatePicker.vue";

export default {
  components: {
    UDatePicker,
  },
  mixins: [MinimumWageMixin],
  props: {
    wageSupplementConfigurationId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      targetWorkingTimeErrorObject: null,
      maxWeeklyWorkHoursErrorObject: null,
      checkBox_DailyWorkhours: false,
      textinput_DailyWorkhours: "",
      checkBox_WeeklyWorkhours: false,
      textinput_WeeklyWorkhours: "",
      checkBox_MonthlyWorkhours: false,
      textinput_MonthlyWorkhours: "",
      checkBox_YearlyWorkhours: false,
      textinput_YearlyWorkhours: "",
      worktimeType: 0,
      checkBox_OtherRules: false,
      inputs_OtherRules: [],
      textinput_OtherRules_TimeFrom: "",
      textinput_OtherRules_TimeTo: "",
      checkBox_WeeklyWorkDays: false,
      textinput_WeeklyWorkDays: "",
      checkBox_MaximumWorkhours_Gav: false,
      textinput_MaximumWorkhours_Gav: "",
      checkBox_MaximumWorkhours_Art9: false,
      checkBox_MaximumWorkhours_Art9_45: false,
      checkBox_MaximumWorkhours_Art9_50: false,
      checkBox_MaxDailyWorkHours: false,
      textInput_MaxDailyWorkHours: "0",
      textinput_MaximumWorkhours_DailyTime: "",
      orginalWorkitemsObejct: null,
      originalTargetWorkingTimeObject: null,
      originalMaxWeeklyWorkingHoursObject: null,
      isLoading: true,
      errorMessage: "In der Eingabe dürfen nur Zahlen eingegeben werden!",
      validationRules: {
        minDays: (v) => v >= 1 || "Mindestens 1 Arbeitstag pro Woche",
        maxDays: (v) => v <= 7 || "Maximal 7 Arbeitstage pro Woche",
      },
    };
  },
  created() {
    this.loadAllWorkItems();
  },
  methods: {
    changedCheckbox(checkbox) {
      if (checkbox !== 1) {
        this.checkBox_DailyWorkhours = false;
      }
      if (checkbox !== 2) {
        this.checkBox_WeeklyWorkhours = false;
      }
      if (checkbox !== 3) {
        this.checkBox_MonthlyWorkhours = false;
      }
      if (checkbox !== 4) {
        this.checkBox_YearlyWorkhours = false;
      }
      if (checkbox !== 5) {
        this.checkBox_OtherRules = false;
      }

      this.worktimeType = this.getWorktimeType();
    },
    getWorktimeType() {
      if (this.checkBox_DailyWorkhours) {
        return 1;
      } else if (this.checkBox_WeeklyWorkhours) {
        return 2;
      } else if (this.checkBox_MonthlyWorkhours) {
        return 3;
      } else if (this.checkBox_YearlyWorkhours) {
        return 4;
      } else if (this.checkBox_OtherRules) {
        return 5;
      }
      return 0;
    },
    changedCheckboxMaximumWorkhours(checkbox) {
      if (checkbox !== 1) {
        this.checkBox_MaximumWorkhours_Art9 = false;
      }
      if (checkbox !== 2) {
        this.checkBox_MaximumWorkhours_Gav = false;
      }
    },
    changedCheckboxMaximumWorkhoursArt(checkbox) {
      if (checkbox !== "checkBox_MaximumWorkhours_Art9_45") {
        this.checkBox_MaximumWorkhours_Art9_45 = false;
      }
      if (checkbox !== "checkBox_MaximumWorkhours_Art9_50") {
        this.checkBox_MaximumWorkhours_Art9_50 = false;
      }
    },
    //Alles Werte Laden
    loadAllWorkItems() {
      this.isLoading = true;
      this.errorObject = null;

      LoadTargetWorkingTime(
        this.contractId,
        this.versionId,
        this.editionId,
        //TODO change to configurationId
        this.editionId,
        this.wageSupplementConfigurationId,
        (response) => {
          this.originalTargetWorkingTimeObject = JSON.parse(
            JSON.stringify(response),
          );
          this.setTargetWorkingTimeFields(response);
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.targetWorkingTimeErrorObject = error;
          this.isLoading = false;
        },
      );
      LoadMaxWeeklyWorkingHours(
        this.contractId,
        this.versionId,
        this.editionId,
        //TODO change to configurationId
        this.editionId,
        this.wageSupplementConfigurationId,
        (response) => {
          this.originalMaxWeeklyWorkingHoursObject = JSON.parse(
            JSON.stringify(response),
          );
          this.setMaxWeeklyWorkingHoursFields(response);
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.maxWeeklyWorkHoursErrorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveTargetWorkingTime() {
      this.isLoading = true;
      SaveTargetWorkingTime(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationId,
        this.getTargetWorkingTimeObject(),
        (response) => {
          this.originalTargetWorkingTimeObject = JSON.parse(
            JSON.stringify(response),
          );
          this.setTargetWorkingTimeFields(response);
          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.targetWorkingTimeErrorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveMaxWeeklyWorkingHours() {
      this.isLoading = true;
      SaveMaxWeeklyWorkingHours(
        this.contractId,
        this.versionId,
        this.editionId,
        this.editionId,
        this.wageSupplementConfigurationId,
        this.getMaxWeeklyWorkingHoursObject(),
        (response) => {
          this.originalMaxWeeklyWorkingHoursObject = response;
          this.setMaxWeeklyWorkingHoursFields(response);

          this.isLoading = false;
        },
        (error) => {
          console.error(error);
          this.maxWeeklyWorkHoursErrorObject = error;
          this.isLoading = false;
        },
      );
    },
    //Alle änderungen Zurücksetzetn und den Orginalen Stand zurückholen
    resetWorkitems() {
      this.isLoading = true;
      if (this.originalTargetWorkingTimeObject) {
        this.setTargetWorkingTimeFields(this.originalTargetWorkingTimeObject);
      }
      if (this.originalMaxWeeklyWorkingHoursObject) {
        this.setMaxWeeklyWorkingHoursFields(
          this.originalMaxWeeklyWorkingHoursObject,
        );
      }
      this.isLoading = false;
    },
    setTargetWorkingTimeFields(targetWorkingTimeObject) {
      this.textinput_DailyWorkhours = null;
      this.textinput_WeeklyWorkhours = null;
      this.textinput_MonthlyWorkhours = null;
      this.textinput_YearlyWorkhours = null;
      this.inputs_OtherRules = [];

      switch (targetWorkingTimeObject.targetWorkingTimeType) {
        case 1:
          this.checkBox_DailyWorkhours = true;
          this.textinput_DailyWorkhours = targetWorkingTimeObject.value;
          break;
        case 2:
          this.checkBox_WeeklyWorkhours = true;
          this.textinput_WeeklyWorkhours = targetWorkingTimeObject.value;
          break;
        case 3:
          this.checkBox_MonthlyWorkhours = true;
          this.textinput_MonthlyWorkhours = targetWorkingTimeObject.value;
          break;
        case 4:
          this.checkBox_YearlyWorkhours = true;
          this.textinput_YearlyWorkhours = targetWorkingTimeObject.value;
          break;
        case 5:
          this.checkBox_OtherRules = true;
          this.inputs_OtherRules =
            targetWorkingTimeObject.targetWorkingTimeRanges;
          break;
      }

      if (targetWorkingTimeObject.weeklyWorkingDays) {
        this.checkBox_WeeklyWorkDays = true;
        this.textinput_WeeklyWorkDays =
          targetWorkingTimeObject.weeklyWorkingDays;
      } else {
        this.checkBox_WeeklyWorkDays = false;
      }

      if (targetWorkingTimeObject.maxDailyWorkingHoursActive === true) {
        this.checkBox_MaxDailyWorkHours =
          targetWorkingTimeObject.maxDailyWorkingHoursActive;
        this.textInput_MaxDailyWorkHours =
          targetWorkingTimeObject.maxDailyWorkingHours;
      }

      this.changedCheckbox(targetWorkingTimeObject.targetWorkingTimeType);
    },
    setMaxWeeklyWorkingHoursFields(maxWeeklyWorkingHoursObject) {
      this.changedCheckboxMaximumWorkhours(
        maxWeeklyWorkingHoursObject.maxWeeklyWorkingHoursType,
      );
      switch (maxWeeklyWorkingHoursObject.maxWeeklyWorkingHoursType) {
        case 1:
          this.checkBox_MaximumWorkhours_Art9 = true;
          this.checkBox_MaximumWorkhours_Art9_45 =
            maxWeeklyWorkingHoursObject.hours45;
          this.checkBox_MaximumWorkhours_Art9_50 =
            maxWeeklyWorkingHoursObject.hours50;
          break;
        case 2:
          this.checkBox_MaximumWorkhours_Gav = true;
          this.textinput_MaximumWorkhours_Gav =
            maxWeeklyWorkingHoursObject.hoursGav.toString();
          break;
        case 0:
        default:
          break;
      }
    },
    //Wird gebraucht um zu Überprüfen ob der Wert 0 ist, wenn der Wert 0 ist, wird das Feld im Frontend leer sein.
    // (Somit musss der Benutzer bei der Eingabe nicht immer den Wert 0 löschen )
    //!!Muss umbedingt gemacht werden, weil die Werte im Backend nicht Nullabel sind
    validateNumberField(fieldValue, type) {
      //Type = 1, für werte welche vom Backend kommen
      //Type = 2, für werte welche ans Backend gesendet werden
      if (fieldValue != 0) {
        return fieldValue;
      } else {
        if (type == 1) {
          return "";
        } else if (type == 2) {
          return 0;
        }
      }
    },
    getTargetWorkingTimeObject() {
      let selectedWorkTimeValue = 0;
      let ranges = [];
      switch (this.worktimeType) {
        case 1:
          selectedWorkTimeValue = this.textinput_DailyWorkhours;
          break;
        case 2:
          selectedWorkTimeValue = this.textinput_WeeklyWorkhours;
          break;
        case 3:
          selectedWorkTimeValue = this.textinput_MonthlyWorkhours;
          break;
        case 4:
          selectedWorkTimeValue = this.textinput_YearlyWorkhours;
          break;
        case 5:
          selectedWorkTimeValue = 0;
          ranges = this.inputs_OtherRules;
          break;
        default:
          selectedWorkTimeValue = 0;
      }
      if (this.originalTargetWorkingTimeObject) {
        return {
          id: this.originalTargetWorkingTimeObject.id,
          targetWorkingTimeType: this.worktimeType,
          value: selectedWorkTimeValue,
          weeklyWorkingDays: this.checkBox_WeeklyWorkDays
            ? this.textinput_WeeklyWorkDays
            : null,
          targetWorkingTimeRanges: ranges,
        };
      }
      return {
        id: this.originalTargetWorkingTimeObject.id,
        targetWorkingTimeType: this.worktimeType,
        value: selectedWorkTimeValue,
        targetWorkingTimeRanges: ranges,
      };
    },
    getMaxWeeklyWorkingHoursObject() {
      let hourValue = 0;
      let type = 0;
      if (this.checkBox_MaximumWorkhours_Gav) {
        hourValue = Number(this.textinput_MaximumWorkhours_Gav);
        type = 2;
      } else if (this.checkBox_MaximumWorkhours_Art9) {
        type = 1;
      }
      return {
        id: this.originalMaxWeeklyWorkingHoursObject.id,
        maxweeklyWorkingHoursType: type,
        hoursGav: hourValue,
        hours45: this.checkBox_MaximumWorkhours_Art9_45,
        hours50: this.checkBox_MaximumWorkhours_Art9_50,
        maxDailyWorkingHoursActive: this.checkBox_MaxDailyWorkHours,
        maxDailyWorkingHours: this.textInput_MaxDailyWorkHours,
      };
    },
    RemoveOtherRuleEntry(ruleToRemoveIndex) {
      this.inputs_OtherRules = this.inputs_OtherRules.filter((rule, index) => {
        return index != ruleToRemoveIndex;
      });
    },
    AddBlankOtherRule() {
      this.inputs_OtherRules.push({
        id: 0,
        targetWorkingTimeId: this.originalTargetWorkingTimeObject
          ? this.originalTargetWorkingTimeObject.id
          : 0,
        dateFrom: "",
        dateTo: "",
        value: null,
      });
    },
  },
};
</script>

<style>
.textField .v-text-field__slot input {
  text-align: right;
}

.alignLeft input {
  text-align: left;
}

.custom_hr {
  padding-top: 20px;

  border: none;
  height: 20px;
  width: 100%;
  height: 50px;
  margin-top: 0;
  border-bottom: 1px solid #d3d3d3;
  box-shadow: 0 5px 5px -5px #d3d3d3;
  margin: -50px auto 5px;
}

.textField {
  width: 100px;
}
</style>
